import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { makesMutations, dataFetched } from 'data/graphql'
import { createErrorToasterMessage } from 'data/ui/actions'
import { noteBaseAttributesFragment } from 'remote/notes'
const setNoteIconQuery = gql`
  mutation setNoteIcon($id: ID!, $input: NoteIconInput!) {
    setNoteIcon(id: $id, input: $input) {
      ...noteBaseAttributes
    }
  }
  ${noteBaseAttributesFragment}
`

export default compose(
  connect(
    null,
    { dataFetched, createErrorToasterMessage }
  ),
  makesMutations({
    query: setNoteIconQuery,
    mutationPropName: 'setNoteIcon',
    getOnResultFromProps: ({ dataFetched }) => ({ result: { data } }) => {
      dataFetched(data.setNoteIcon)
    },
    getOnErrorFromProps: ({ createErrorToasterMessage }) => ({ error }) => {
      createErrorToasterMessage({
        title: `Error while saving doc as template: ${error.message}`,
      })
    },
  })
)
